import uniqBy from 'lodash/uniqBy';
import pick from 'lodash/pick';

export function getContracts(groups) {
  if (!groups || groups.length === 0) return [];
  const allContracts = groups.map((g) => pick(g, ['idContract', 'contractName']));
  return uniqBy(allContracts, (c) => c.idContract);
}

export function getContractOptions(groups) {
  if (!groups || groups.length === 0) return [];
  const allContracts = groups.map((g) => ({ value: g.idContract, label: g.contractName }));
  return uniqBy(allContracts, (c) => c.value);
}

export function getApplicationOptions(groups, idContract) {
  if (!groups || groups.length === 0) return [];
  const allApplication = groups
    .filter((g) => !idContract || Number(g.idContract) === Number(idContract))
    .map((g) => ({ value: g.idApplication, label: `${g.aplicationName}`, year: g.year }));
  return uniqBy(allApplication, (s) => s.value).sort((a, b) => {
    if (a.label > b.label) {
      return -1;
    }
    if (a.label < b.label) {
      return 1;
    }
    return 0;
  });
}

export function getEvaluationOptions(groups, idApplication) {
  if (!groups || groups.length === 0) return [];
  const allEvaluation = groups
    .filter((g) => !idApplication || Number(g.idApplication) === Number(idApplication))
    .map((g) => ({
      value: g.idEvaluation,
      label: g.merged ? `${g.identification} (${g.idEvaluation})` : `${g.identification} / ${g.levelName} / ${g.book} (${g.idEvaluation})`,
      year: g.year,
    }));
  return uniqBy(allEvaluation, (s) => s.value);
}

// export function getLevelOptions(groups, idEvaluation) {
//   if (!groups || groups.length === 0) return [];
//   const allLevel = groups
//     .filter((g) => !idEvaluation || Number(g.idEvaluation) === Number(idEvaluation))
//     .map((g) => ({ value: g.idLevel, label: `${g.levelName}`, year: g.year }));
//   return uniqBy(allLevel, (s) => s.value);
// }

// export function getSchoolOptions(groups, idApplication) {
//   if (!groups || groups.length === 0) return [];
//   const allSchools = groups
//     .filter((g) => !idApplication || Number(g.idApplication) === Number(idApplication))
//     .map((g) => ({ value: g.idCSchool, label: `${g.schoolName} - ${g.schoolCity}`, year: g.year }));
//   return uniqBy(allSchools, (s) => s.value);
// }

export function getSchoolOptions(groups, idEvaluation) {
  if (!groups || groups.length === 0) return [];
  const allSchools = groups
    .filter((g) => !idEvaluation || Number(g.idEvaluation) === Number(idEvaluation))
    .map((g) => ({ value: g.idCSchool, label: `${g.schoolName}${g.schoolCity ? ' - ' + g.schoolCity : ''}`, year: g.year }));
  return uniqBy(allSchools, (s) => s.value);
}

export function getClassOptions(groups, idEvaluation, idCSchool) {
  if (!groups || groups.length === 0) return [];
  const allClasses = groups
    .filter(
      (g) =>
        (!idEvaluation || Number(g.idEvaluation) === Number(idEvaluation)) &&
        (!idCSchool || Number(g.idCSchool) === Number(idCSchool)),
    )
    .map((g) => ({
      ...g,
      value: g.idESCourse,
      label: `${g.levelName} - ${g.courseName} - ${g.period}`,
    }));
  return uniqBy(allClasses, (c) => c.value);
}

export function getInitials(name) {
  if (!name) return '';
  const parts = name.replace(/[^\w\s]/gi, '').split(' ');
  let initials = '';
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].length > 0 && parts[i] !== '' && isNaN(parts[i]) && initials.length < 2) {
      initials += parts[i][0];
    }
  }

  initials = initials.toUpperCase();
  return initials;
}
